import PropTypes from 'prop-types';
import ODropDownMenu from '../../../UI/DropDownMenu/ODropDownMenu';
import { useTranslation } from 'react-i18next';

const GridOptions = ({ children, handleOpenDialog, openMasine }) => {
  const { t, i18n } = useTranslation();
  const options = [
    {
      title: t('Mašine'),
      subtitle: t('Mašine'),
      path: 'profil',
      id: 1,
      icon: 'fas fa-cogs',
      color: '#2f3a3f',
      onClick: () => openMasine(),
    },
    {
      title: t('buttons.delete'),
      subtitle: t('buttons.delete'),
      path: 'login',
      id: 2,
      icon: 'fas fa-trash',
      color: '#ff5552',
      onClick: () => handleOpenDialog(),
    },
  ];

  return (
    <ODropDownMenu align="end" position="anchor" options={options}>
      {children}
    </ODropDownMenu>
  );
};

GridOptions.propTypes = {
  children: PropTypes.node.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
};

export default GridOptions;
